import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';


////import language 
import fa from './fa';
import en from './en';
import ar from './ar';

///get Language Suport


const resources = {
    en: {
        translation: en
    },
    fa: {
        translation: fa
    },
    ar: {
        translation: ar
    },
}




i18n
    .use(initReactI18next)
    .init({
        resources,
        debug: true,
        lng: "fa",
        // lng: store.getState().user.language.toN,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });



// export const init = () => {

//     return (
//         i18next
//             .use(initReactI18next)
//             .init({
//                 // fallbackLng: resources,
//                 resources,
//                 debug: true,
//                 // lng: store.getState().user.language

//                 interpolation: {
//                     escapeValue: false, // not needed for react as it escapes by default
//                 },
//             })
//     );
// };

// export default init;

export default i18n;